<template>
  <div>
    <f-alert
      visible
      class="my-2"
      theme="warning">
      <span>
       {{ $t('opinion.opinionViolates') }}
      </span>
    </f-alert>

    <div :class="{'is-loading': !loaded}">
      <template v-if="loaded">
        <f-opinion
          v-for="(opinion, index) in (onDashboard ? opinions.latest_opinions : opinions)"
          :key="index"
          class="mb-2"
          :opinion="opinion"
          :isSmall="onDashboard" />
      </template>
    </div>

    <template v-if="!onDashboard">
      <pagination
        :hasWrapper="true"
        :meta-data="paginationMetaData"
        :elementsCounterLabel="'inquiries'" />
    </template>

    <div
      v-if="!loaded && !loadError"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
    <div class="wrapper mt-3">
      <f-alert
        v-if="loadError"
        visible
        theme="warning">
        <span>
          {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
        </span>
      </f-alert>
    </div>
  </div>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import Pagination from '@/components/core/Pagination.vue';
import HasFilters from '@/mixins/HasFilters.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import FOpinion from '@/components/layout/FOpinion.vue'

export default {
  name: 'opinions-list',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    FOpinion
  },
  props: {
    onDashboard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opinions: {
        latest_opinions: []
      },
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadItemsData();
  },
  methods: {
    loadItemsData () {
      let endpointUrl = this.onDashboard ? '/api/adviser/dashboard/opinions' : '/api/adviser/users/opinions/items';

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: endpointUrl,
        listField: 'opinions'
      });
    },
    formatDate (timestamp) {
      if (!timestamp) {
        return this.$t('ui.none');
      }

      let dateObject = new Date(timestamp);

      return [
        dateObject.getFullYear(),
        dateObject.getMonth() + 1,
        dateObject.getDate()
      ].map(n => n < 10 ? '0' + n : n).join('-') + ' ' + [
        dateObject.getHours(),
        dateObject.getMinutes()
      ].map(n => n < 10 ? '0' + n : n).join(':');
    },

  }
};
</script>
